<template>
    <div>
        <p>{{ latest_risk_notice }}</p>
        <el-button class="ignore-button" @click="onClickIgnoreNotice">忽略</el-button>
        <el-button class="read-button" @click="onClickReadNotice">检查风控通知</el-button>
    </div>
</template>

<script>
export default {
    name: "risknoticepopup",
    data(){
        return{
            risk_notice_content: '',
            latest_risk_notice:'',
            audio:''
        }
    },
    methods:{
        // read notice button click function
        onClickReadNotice() {
            localStorage.removeItem('risk_notice_id');
            localStorage.removeItem('risk_notice_content');
            localStorage.setItem('riskNoticeSoundrun',0);
            this.audio.pause(); 
            // Emit event when read notice button
            this.$emit('read-click');
        },
        // ignore notice button click function
        onClickIgnoreNotice(){ 
            localStorage.removeItem('risk_notice_id');
            localStorage.removeItem('risk_notice_content');
            localStorage.setItem('riskNoticeSoundrun',0);
            this.audio.pause(); 
            // Emit event for closing notice button
            this.$emit('ignore-click');
        },
    },
    mounted(){
        // get risk notice content from localstorage
        this.latest_risk_notice = localStorage.getItem('risk_notice_content');
        this.audio = new Audio(localStorage.getItem('riskNoticeSound'));
        if(localStorage.getItem('riskNoticeSoundrun')!=1){
            this.audio.play();
        }
        localStorage.setItem('riskNoticeSoundrun',1);
    }
};
</script>
<style>
/* Custom style for top-center notification */
.top-center-notification{
  position: fixed !important;
  top: 140px !important; 
  left: 50% !important;
  transform: translateX(-50%) !important; 
  margin: 0 !important;
  z-index: 9999 !important; 
}
.ignore-button, .ignore-button:hover{
    color: #EE5C35!important;
    background-color: #FFFFFF!important;
}
.read-button, .read-button:hover{
    color: #FFFFFF!important;
    background-color: #EE5C35!important;
}
</style>



// WEBPACK FOOTER //
// src/components/risknoticepopup.vue